import RatingView from './RatingView';

export default RatingView;
